import { FeatureFlags } from '../../data-types/feature-flags/featureFlagsInterfaces';
import { CountrySettings } from '../../data-types/international/internationalInterfaces';
import { WalletSettings } from '../../data-types/wallet/walletInterfaces';
import { store } from '../store';
import {
  SET_ALL_AVAILABLE_COUNTRY_SETTINGS,
  SET_BET_PLACEMENT_ROCKET_ANIMATION,
  SET_BETKWIFF_DOMAIN_FLAG,
  SET_CAN_PLAY_CASINO,
  SET_CAN_SHOW_AVIATOR,
  SET_CASINO_FIRST_FLAG,
  SET_COUNTRY_SETTINGS_BY_LOCATION,
  SET_FEATURE_FLAGS,
  SET_MAINTENANCE,
  SET_MOODBAR_SCORE,
  SET_NET_PROMOTER_SCORE_FLAG,
  SET_REORDER_CASINO_FILTERS,
  SET_WALLET_SETTINGS,
} from '../types/customizationTypes';

export const setCasinoFirstFlag = (flag: boolean) => {
  store.dispatch({
    type: SET_CASINO_FIRST_FLAG,
    meta: flag,
  });
};

export const setFeatureFlags = (meta: FeatureFlags) => {
  store.dispatch({
    meta,
    type: SET_FEATURE_FLAGS,
  });
};

export const setBetkwiffDomainFeatureFlag = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_BETKWIFF_DOMAIN_FLAG,
  });
};

export const setMoodBarScore = (meta: number) => {
  store.dispatch({
    meta,
    type: SET_MOODBAR_SCORE,
  });
};

export const setMaintenance = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_MAINTENANCE,
  });
};

export const setWalletSettings = (meta: WalletSettings) => {
  store.dispatch({
    meta,
    type: SET_WALLET_SETTINGS,
  });
};

export const setAllAvailableCountrySettings = (meta: CountrySettings[]) => {
  store.dispatch({
    meta,
    type: SET_ALL_AVAILABLE_COUNTRY_SETTINGS,
  });
};

export const setCountrySettingsByLocation = (meta: CountrySettings | undefined) => {
  store.dispatch({
    meta,
    type: SET_COUNTRY_SETTINGS_BY_LOCATION,
  });
};

export const setCanPlayCasino = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_CAN_PLAY_CASINO,
  });
};

export const setNetPromoterScoreFlag = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_NET_PROMOTER_SCORE_FLAG,
  });
};

export const setReorderCasinoFilters = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_REORDER_CASINO_FILTERS,
  });
};

export const setCanShowAviator = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_CAN_SHOW_AVIATOR,
  });
};

export const setBetPlacementRocketAnimation = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_BET_PLACEMENT_ROCKET_ANIMATION,
  });
};
